import EmailModal from '@/components/auth/FindPwd/EmailModal';

const EmailPage = () => {
  return <EmailModal />;
};

export default EmailPage;
